const TrackerFix = (params) => {
  if (typeof window === 'undefined') return
  let pageOptions = {
    page_type: 'landing'
  }
  if (params.agent && typeof params.agent === 'string') {
    pageOptions.agent = params.agent
    if (!/(?:^| )agent=([^;]{3,6})/.test(document.cookie)) { // No agent cookie set already
      document.cookie = `agent=${params.agent}` // Ensure the page's cookie matches the agent sent in the page tracking
    }
  }
  window.tracker.initialise({
    env: params.environment || process.env.NODE_ENV || 'production',
    service: params.service || 'seo',
    organisation: 'Airparks Services Limited',
    schemaVersions: params.schemaVersions || {}
  })
  if (params.pageOptions) pageOptions = Object.assign({}, pageOptions, params.pageOptions)
  window.tracker.page(params.eventType || 'landing', pageOptions)
  window.tracker.inline('auto_capture', { name: 'tech_platform', value: params.techPlatform || 'ssg' })
  if (params.templateGroup) window.tracker.inline('auto_capture', { name: 'template_group', value: params.templateGroup })
}

module.exports = TrackerFix



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/trackerFix.js